import { A_VISTA, A_PRAZO } from '../../utils';

const choices = [
  { id: A_VISTA, name: 'À Vista' },
  { id: A_PRAZO, name: 'À Prazo' },
];

export default choices;
